import { Component, Input, OnInit } from "@angular/core";
import { PlayerShortDto } from "app/models";
import { TeamCardDto } from "app/models/dtos/team-card.dto";

@Component({
    selector: 'team-data',
    templateUrl: './team-data.component.html',
    styleUrls: ['./team-data.component.scss'],
})
export class TeamData implements OnInit {
    private team: TeamCardDto;

    @Input()
    set teamData(val: TeamCardDto) {
        this.team = val;
    }
    
    get teamData(): TeamCardDto {
        return this.team;
    }
    
    ngOnInit(): void {
        
    }

    formatFinance(val: number | undefined): string {
        if (!val) return ;

        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    getPlayerPos(player: PlayerShortDto): string {
        if (player.isGK)
            return "GK";
        if (player.isSW)
            return "SW";
        if (player.isDF)
            return "DF";
        if (player.isDM)
            return "DM";
        if (player.isMF)
            return "MF";
        if (player.isAM)
            return "AM";
        return "FW";
    }

}